export default "__VITE_ASSET__ti9kgfoR__"